// extracted by mini-css-extract-plugin
export default {"error":"hAQc0","button":"fzwUg"};